<template>
  <div class="campaign">
    <div class="campaign__header">
      <div class="campaign__header__back">
        <i class="adx-ic_arrow_left"></i>
        <span class="text" @click.stop="goToListCampaign">Campaigns</span>
      </div>
      <div class="campaign__header__title">
        <h2 class="medium-title">Edit Campaign</h2>
      </div>
    </div>
    <div class="campaign__main">
      <form action="" id="cammpaign-form" class="campaign-form" @submit.prevent="onSubmit">      
      <div class="campaign__main__left">
        <div class="campaign__main__left__campaign_selection">
          <adx-input
            label="Campaign Name"
            :value.sync="campaignName"
            :validation="['NewNotEmpty', 'NewMaxLength:190', 'NewMinLength:3', 'Alphanumeric']"
            ref="campaignInput"
            inputId="campaignInput"
            :error.sync="campaignNameErr"/>
        </div>
        <div class="campaign__main__left__btn_schedule">
          <button type="button" class="secondary btn-large" @click.stop="addSchedule">Create Schedule</button>
        </div>        
        <div v-for="(schedule, index) in schedules" :key="index" class="campaign__main__left__schedule">
          <div class="campaign__main__left__schedule__header">
            <div class="campaign__main__left__schedule__header__line"></div>
            <span class="campaign__main__left__schedule__header__text">Schedule</span>
            <span class="campaign__main__left__schedule__header__icon">
              <div class="icon-wrapper"><i @click="showDeleteScheduleModal(schedule, index)" class="icon-deleted"></i></div>
            </span>
          </div>
          <div class="campaign__main__left__schedule__task">
            <div :class="['calendar', 'task-start', schedule.taskStart == null ? 'warning' : '']">
              <label class="small-font">Task Start</label>
              <v-date-picker
                v-model='schedule.taskStart'
                :min-date='new Date()'
                :popoverVisibility="'focus'"
                :theme-styles='themeStyles'
                class='date-input'>
                <input
                  class="calendar-start"
                  placeholder= "DD/MM/YYYY"
                  type='text'
                  slot-scope='{ inputValue, updateValue }'
                  :value='inputValue'
                  @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                  @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
              </v-date-picker>
            </div>
            <adx-input 
              :label="`Visit Period`" 
              :value.sync="schedule.visitPeriod" 
              :icon="`day`" 
              class="visit-period"
              :validation="['Numeric', 'NewNotEmpty']" 
              :error.sync="errors.periodeInput" />
          </div>
          <div v-for="(listing, listingIndex) in schedule.listings" :key="listingIndex" class="campaign__main__left__location_placement">
          <h1>Locations</h1>
            <div class="campaign__main__left__location_placement__row">
              <div class="campaign__main__left__location_placement__row__wrapper">
                <adx-input
                :class="[ listing.locationInput == null ? 'warning' :'']"
                :label="`Location`" :value.sync="listing.locationInput"
                :validation="['NewNotEmpty', 'NewMinLength:3', 'NewMaxLength:200', 'Alphanumeric']"
                :ref="dataRef.locationInput" :error.sync="errors.locationInput[listingIndex]"
                :inputId="`location_${index}_${listingIndex}`"/>
                <div class="icon-wrapper"><i @click="deleteListing(index, listingIndex)" class="icon-deleted"></i></div>
              </div>
              <div v-if="listing.latitude && listing.longitude" class="campaign__main__left__location_placement__row__bottom">Coordinate have been set <span @click="openModalCoordinate(index, listingIndex)" class="change">Change</span></div>
              <div v-else class="campaign__main__left__location_placement__row__coordinate-btn"><span class="text" @click.stop="openModalCoordinate(index, listingIndex)">Set Coordinate</span></div>
              <h1>Placement Per Location ({{countPlacement(listing.placements)}})</h1>
              <div v-for="(placement, placementIndex) in listing.placements" :key="placementIndex" class="campaign__main__left__location_placement__row__wrapper">
                <adx-input
                  :class="[ listing.placementInput == null ? 'warning' :'']"
                  :label="`Placement`" :value.sync="placement.placementInput"
                  :validation="['NewNotEmpty', 'NewMinLength:3', 'NewMaxLength:190', 'Alphanumeric']"
                  :ref="dataRef.placementInput" :error.sync="errors.placementInput[placementIndex]"
                  :inputId="`placement_${index}_${listingIndex}_${placementIndex}`"/>
                <div class="icon-wrapper"><i @click="deletePlacement(listing, placementIndex)" class="icon-deleted"></i></div>
              </div>
              <div class="line-wrapper">
                <hr class="line">
              </div>
              <div class="campaign__main__left__location_placement__row__more-placement">
                <span class="text" @click.stop="addPlacement(listing)">Add More Placement</span>
              </div>
            </div>
          </div>
          <button type="button" class="secondary btn-block more-location" @click.stop="addListing(index)">Add Location</button>
        </div>
      </div>
      <div class="campaign__main__right">
        <div class="campaign__main__right__date">
          <adx-single-search-dropdown :label="`Owner`" class="dropdown" :value.sync="owner" :optionsParam="userOptions"/>
        </div>
        <div class="campaign__main__right__date">
          <div class="campaign__main__right__date__title">
            <h1>Campaign Date</h1>
          </div>
          <div :class="['calendar', startDate == null && !startDateIsValid ? 'warning' : '']">
            <label class="small-font">Start Date</label>
            <v-date-picker
              v-model='startDate'
              :min-date='new Date()'
              :popoverVisibility="'focus'"
              :theme-styles='themeStyles'
              class='date-input'>
              <input
                class="calendar-start"
                placeholder= "DD/MM/YYYY"
                type='text'
                slot-scope='{ inputValue, updateValue }'
                :value='inputValue'
                ref="startDate"
                :required="true"
                @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
            </v-date-picker>
          </div>
          <div :class="['calendar', endDate == null && !endDateIsValid ? 'warning' : '']">
            <label class="small-font">End Date</label>
            <v-date-picker
              v-model='endDate'
              :min-date='startDate ? startDate : new Date()'
              :popoverVisibility="'focus'"
              :theme-styles='themeStyles'
              class='date-input'>
              <input
                class="calendar-start"
                placeholder= "DD/MM/YYYY"
                type='text'
                slot-scope='{ inputValue, updateValue }'
                :value='inputValue'
                ref="endDate"
                :required="true"
                @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
            </v-date-picker>
          </div>
        </div>
        <div class="campaign__main__right__date">
          <adx-input :label="`Price`" :value.sync="price"/>
          <!-- <div class="campaign__main__right__date__title__status">
            <h1>Payment</h1>
          </div>
          <dropdown-status class="campaign__main__right__date__status" 
            @selected="selectPayment" 
            :list="paymentList" 
            labelButton="Status"
            :display="selectedPayment" /> -->
        </div>
        <button type="submit" class="primary btn-block save" :disabled='isLoading'>
          <span>Save Campaign</span>
          <loading-secondary v-if="isLoading"/>
        </button>
      </div>
      </form>
    </div>
    <adx-modal
      v-if="deleteScheduleModal"
      type="small"
      @modal-close="cancelDeleteSchedule()">
        <div slot="content" class="modal-delete">
          <p class="medium-title strong color-black title">Delete Visit Schedule?</p>
          <p class="confirm">Are you sure want to delete this schedule ? <br/> Note : this action can’t be undo. </p>
          <div class="buttons">
            <button 
              type="button" 
              class="secondary btn-large cancel" 
              @click.stop="cancelDeleteSchedule()" 
              :disabled="deleting">Cancel</button>
            <button
              type="button" 
              class="primary btn-large delete"
              @click.stop="deleteSchedule()" 
              :disabled="deleting">
                Delete
                <adx-loading-circle v-if="deleting" class="loading-circle" />
              </button>
          </div>
        </div>
    </adx-modal>
    <adx-modal
      v-if="showModalCoordinate"
      type="small"
      title="Set Coordinate"
      :hideClose="true">
      <div slot="content" class="campaign__modal">
        <div class="campaign__modal__search_map">
          <i class="adx-ic_search"></i>
          <gmap-autocomplete
            @place_changed="setPlace">
          </gmap-autocomplete>
        </div>
        <GmapMap
          :center="center"
          :zoom="15"
          map-type-id="terrain"
          style="width: 100%; height: 200px"
          ref="mapRef"
          :options="{
            mapTypeControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            disableDefaultUi: false }">
          <GmapMarker
            :position="center"
            :clickable="false"
            :draggable="false"/>
        </GmapMap>
        <div class="campaign__modal__place_data">
          <span>Country <strong>{{currentPlace ? currentPlace.country.long_name : 'Indonesia'}}</strong></span>
          <span>Province <strong>{{currentPlace ? currentPlace.province.long_name : 'DKI Jakarta'}}</strong></span>
          <span>City <strong>{{currentPlace ? currentPlace.city.long_name : 'Jakarta Selatan'}}</strong></span>
          <span>Area <strong>{{currentPlace ? currentPlace.area.long_name : 'Kuningan'}}</strong></span>
          <span>Address <strong>{{currentPlace ? currentPlace.address : ''}}</strong></span>
        </div>
        <div class="campaign__modal__buttons">
          <div class="campaign__modal__buttons__cancel">
            <button type="button" class="secondary btn-block" @click.stop="closeModalCoordinate">Cancel</button>
          </div>
          <div class="campaign__modal__buttons__save">
            <button type="button" class="primary btn-block" @click.stop="saveCoordinate" :disabled="!currentPlace">Save</button>
          </div>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import moment from 'moment'
import calendar from 'v-calendar'
import Input from '@/components/Form/Input'
import Modal from '@/components/Modal'
import triggerValidation from "@/lib/triggerValidation"
import LoadingSecondary from '@/components/Loading/Secondary'
import LoadingCircle from '@/components/Loading/Secondary-white'
import SingleSearchDropdown from '@/components/Dropdown/SingleSearchDropdown'
import DropdownStatus from '@/components/Dropdown/StatusDropdown'

import * as validationLib from '@/lib/validation/'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { gmapApi } from 'vue2-google-maps'
import { async } from 'q';

const {
  helpers
} = validationLib

export default {
  name: 'adx-monitoring-new-campaign',
  components: {
    'adx-input': Input,
    'adx-modal': Modal,
    'loading-secondary': LoadingSecondary,
    'adx-single-search-dropdown': SingleSearchDropdown,
    'adx-loading-circle': LoadingCircle,
    DropdownStatus,
  },
  props: {

  },
  data() {
    return {
      id: undefined,
      deleteScheduleModal: false,
      deleting: false,
      price: 0,
      selectedPayment: {
        id: 1,
        label: 'PENDING',
        value: 'pending'
      },
      paymentList:[
        {
          'id': 1,
          'label': 'PENDING',
          'value': 'pending'
        },
        {
          'id': 2,
          'label': 'PAID',
          'value': 'paid'
        },
        {
          'id': 3,
          'label': 'DOWNPAYMENT',
          'value': 'downpayment'
        },
        {
          'id': 4,
          'label': 'PARTIALLY',
          'value': 'partially'
        },
        {
          'id': 5,
          'label': 'AFTERPAY',
          'value': 'afterpay'
        },
      ],
      schedules: [],
      campaignName: '',
      campaignNameErr: '',
      owner: null,
      tmpIndex: undefined,
      listCampaign: [
        {
          id: 1,
          label: 'BliBli Jakarta Run 2019',
          value: 1
        },
        {
          id: 2,
          label: 'BliBli Jakarta Run 2019',
          value: 2
        },
        {
          id: 3,
          label: 'BliBli Jakarta Run 2019',
          value: 3
        }
      ],
      totalRow: 1,
      isCoordinatSet: false,
      isLoading: false,
      isShowModalCoordinate: false,
      indexModal: null,
      userOptions:[],
      dataRef: {
        titleInput: 'titleInput',
        locationInput: 'locationInput',
        placementInput: 'placementInput',
        periodeInput: 'periodeInput'
      },
      errors: {
        titleInput: null,
        periodeInput: null,
        locationInput: [
          null
        ],
        placementInput: [
          null
        ],
      },
      periode: null,
      taskStart: null,
      inputDate: null,
      startDate: null,
      endDate: null,
      startDateIsValid: true,
      endDateIsValid: true,
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
      attributes: [
        {
          dot: {
            backgroundColor: '#ff3b30',
          },
          dates: [],
        },
      ],
      showModalCoordinate: false,
      center: {
        lat: -7.090910999999999, lng: 107.668887
      },
      currentPlace: null,
      locationIndex: null,
      scheduleIndex: null,
    }
  },
  computed: {
    google: gmapApi,
  },
  watch: {
    'startDate': function (){
      this.taskStart = this.startDate
    }

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.id = this.$route.params.id
  },
  mounted() {
    this.initialLoad()
    this.geolocate()
    this.loadData()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    onSubmit() {
      let isValid = true
      if (this.schedules.length == 0) {
        this.showNotification('Schedule', 'There\'s at least 1 schedule', 'warning')
        return
      }

      this.schedules.some((schedule, index) => {
        let listingInvalid = false
        if (schedule.listings.length == 0) {
          isValid = false
          this.showNotification('Schedule', 'Every schedule must have at least 1 location', 'warning')
          return true
        }
        schedule.listings.some((listing, listingIndex) => {
          if (!listing.city || !listing.area || !listing.latitude || !listing.longitude) {
            listingInvalid = true
            this.showNotification('Location', 'Please complete location information', 'warning')
            document.getElementById(`location_${index}_${listingIndex}`).focus()
            return true
          }

          if (listing.placements.length == 0) {
            listingInvalid = true
            this.showNotification('Location', 'Every Location must have at least 1 placement', 'warning')
            return true
          }
        })

        if (listingInvalid) {
          isValid = false
          return true
        }
      })

      if (isValid) {
        this.saveCampaign()
      }
    },
    showNotification(title, message, type) {
      this.$notify({
        group: 'saved',
        title: title,
        text: message,
        type: type
      })
    },
    initialLoad(){
      (async () =>{
        const { data } = await api.get(apiV2.getUser, { needToken: true })
        data.results.map(user => {
          this.userOptions.push(
            {
              value: user.id,
              label: user.email
            }
          )
        })
    })();
    },
    async loadData() {
      this.isLoading = true
      const { data } = await api.get(apiV2.taskManagerCampaignEdit(this.id), {needToken: true})
      this.campaignName = data.title
      this.owner = data.owner
      this.startDate = this.stringToDate(data.start)
      this.endDate = this.stringToDate(data.end)
      this.price = data.total_price
      this.mapListing(data.listing_set)
    },
    stringToDate(sourceDate){
      return moment(sourceDate, 'DD/MM/YYYY').toDate()
    },
    mapListing(listings){
      listings.map(listing => {
        let checkSchedules = this.schedules.filter( (item) => {
          return moment(item.taskStart).isSame(this.stringToDate(listing.task_start))
        })
        const taskStart = moment(listing.task_start,'DD/MM/YYYY').toDate()
        if(checkSchedules.length==0){
          this.schedules.unshift({
            taskStart: taskStart,
            visitPeriod: listing.recurring_duration,
            listings: this.getListingLocation(listings, listing.task_start),
          })
        }
      })
      this.isLoading = false
    },
    getListingLocation(listings, start_date){
      let tmpLocation = []
      listings.map(listing => {    
        let checkTmpLocation = tmpLocation.filter(item => item.latitude === listing.latitude && item.longitude === listing.longitude) 
        if(listing.task_start === start_date && checkTmpLocation.length == 0){
          tmpLocation.push({
          area: listing.area,
          city: listing.city,
          latitude: listing.latitude,
          locationInput: listing.location_name,
          longitude: listing.longitude,
          placements: this.getListingPlacement(listings, listing.latitude, listing.longitude),
          })
        }
      })
      return tmpLocation
    },
    getListingPlacement(listings, latitude, longitude){
      let tmpPlacement = []
      listings.map(listing => {
        if(listing.latitude == latitude && listing.longitude == longitude){
          tmpPlacement.push({placementInput: listing.placement})
        }
      })
      return tmpPlacement
    },
    // deleteItem(index) {
    //   this.model.listings.splice(index, 1)
    // },
    setPlace(place) {
      let lat = place.geometry.location.lat()
      let lng = place.geometry.location.lng()
      this.currentPlace = {
        lat: lat,
        lng: lng,
        address:  place.formatted_address,
        country:  this.getPlaceData(place.address_components, 'country'),
        province:  this.getPlaceData(place.address_components, 'administrative_area_level_1'),
        city:  this.getPlaceData(place.address_components, 'administrative_area_level_2'),
        area:  this.getPlaceData(place.address_components, 'administrative_area_level_3'),
      }
      this.center = this.currentPlace
    },
    getPlaceData(data, search) {
      const results = data.filter(x => x.types.includes(search))
      if (results.length > 0) {
        return results.pop()
      }
      return null
    },
    saveCoordinate() {
      this.model.listings[this.locationIndex].latitude = this.currentPlace.lat
      this.model.listings[this.locationIndex].longitude = this.currentPlace.lng
      this.model.listings[this.locationIndex].city = this.currentPlace.city.long_name
      this.model.listings[this.locationIndex].area = this.currentPlace.area.long_name
      this.currentPlace = null
      this.locationIndex = null
      this.isCoordinatSet = true
      this.toggleModalCoordinate()
    },
    closeModalCoordinate() {
      this.currentPlace = null
      this.locationIndex = null
      this.toggleModalCoordinate()
    },
    toggleModalCoordinate() {
      this.showModalCoordinate = !this.showModalCoordinate
    },
    openModalCoordinate(index) {
      this.locationIndex = index
      this.toggleModalCoordinate()
    },
    goToListCampaign() {
      this.$router.push({ name: 'campaignmonitoring' })
    },
    validate() {
      
    },
    // countPlacement(placements){
    //   if (placements) return placements.length
    // },
    addListing(listing) {
      this.model.listings.push(
        {
          location: '',
          placements: [{item: ''}],
          coordinate: ''
        }
      )
    },
    addPlacement(listing) {
      listing.placements.push(
        {
          item: null
        }
      );
    },
    deleteListing(listing, index) {
      if (listing.length > 1) {
        listing.splice(index, 1);
      } else {
        this.$notify({
          group: 'saved',
          title: 'Delete Error',
          text: 'Oops data can not be deleted!',
          type: 'danger'
        });
      }
    },
    deletePlacement(listing, index){
      if (listing.placements.length > 1) {
        listing.placements.splice(index, 1);
      } else {
        this.$notify({
          group: 'saved',
          title: 'Delete Error',
          text: 'Oops data can not be deleted!',
          type: 'danger'
        });
      }
    },
    saveCampaign() {
      const start = this.startDate ? moment(this.startDate).format('YYYY-MM-DD') : null
      const end = this.endDate ? moment(this.endDate).format('YYYY-MM-DD') : null
      const taskDate = moment(this.taskStart).format('YYYY-MM-DD')

      let tempListing = []
      this.schedules.forEach((schedule) => {
        schedule.listings.forEach(listing => {
          listing.placements.forEach(placement => {
            tempListing.push({
              area: listing.area,
              city: listing.city,
              latitude: listing.latitude,
              longitude: listing.longitude,
              location_name: listing.locationInput,
              placement: placement.placementInput,
              start: start,
              end: end,
              task_start: moment(schedule.taskStart).format('YYYY-MM-DD'),
              recurring_duration: schedule.visitPeriod
            })
          })
        })
      })

      const body = {
        title: this.campaignName,
        owner: this.owner,
        start: start,
        end: end,
        listing_set: tempListing,
        total_price: this.price,
        payment_status: this.selectedPayment.id
      }

      this.submit(body)
    },
    submit(body) {
      (async () => {
        this.isLoading = true
        const response = await api.put(apiV2.taskManagerCampaignEdit(this.id), body,{needToken: true})
        if (response.status == 200 || response.status == 201) {
          this.isLoading = false
          this.goToListCampaign()
        } else {
          this.isLoading = false
          if (response.status == 400) {
            const { error } = response.data
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: error,
              type: 'danger'
            });
          } else if (response.status == 404) {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: 'Ticket Not Found',
              type: 'danger'
            });
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: `Sorry something went wrong! (Error code: ${response.status})`,
              type: 'warn'
            })
          }
        }
      })();
    },
    toggleModal(index = null){
      if (index !== null) {
        this.indexModal = index
      }
      this.isShowModalCoordinate = !this.isShowModalCoordinate
    },
    countPlacement(placements){
      return placements.length
    },
    addListing(index) {
      this.schedules[index].listings.push({
        locationInput: null,
        placements: [],
        latitude: '',
        longitude: '',
        city: '',
        area: '',
      })
    },
    addPlacement(listing) {
      listing.placements.push(
        {
          placementInput: null,
        }
      );
    },
    deleteListing(scheduleIndex, listingIndex) {
      this.schedules[scheduleIndex]['listings'].splice(listingIndex, 1)
    },
    deletePlacement(listing, index){
      if (listing.placements.length > 1) {
        listing.placements.splice(index, 1);
        this.errors.placementInput.splice(index,1);
      } else {
        this.$notify({
          group: 'saved',
          title: 'Delete Error',
          text: 'Oops data can not be deleted!',
          type: 'danger'
        });
      }
    },
    showDeleteScheduleModal(schedule, index){
      this.tmpIndex = index
      this.toggleDeleteScheduleModal()
    },
    toggleDeleteScheduleModal(){
      this.deleteScheduleModal = !this.deleteScheduleModal
    },
    deleteSchedule(){
      this.schedules.splice(this.tmpIndex, 1)
      this.toggleDeleteScheduleModal()
    },
    cancelDeleteSchedule(){
      this.toggleDeleteScheduleModal()
    },
    goToListCampaign() {
      this.$router.push({ name: 'campaignmonitoring' })
    },
    searchLocation: function() {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({'address': 'Jakarta, Indonesia'}, (results, status) => {
        if (status === 'OK') {
          this.currentLocation.lat = results[0].geometry.location.lat();
          this.currentLocation.lng = results[0].geometry.location.lng();
        }
      });
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    getPlaceData(data, search) {
      const results = data.filter(x => x.types.includes(search))
      if (results.length > 0) {
        return results.pop()
      }
      return null
    },
    setPlace(place) {
      let lat = place.geometry.location.lat()
      let lng = place.geometry.location.lng()
      this.currentPlace = {
        lat: lat, lng: lng,
        address:  place.formatted_address,
        country:  this.getPlaceData(place.address_components, 'country'),
        province:  this.getPlaceData(place.address_components, 'administrative_area_level_1'),
        city:  this.getPlaceData(place.address_components, 'administrative_area_level_2'),
        area:  this.getPlaceData(place.address_components, 'administrative_area_level_3'),
      }
      this.center = this.currentPlace
    },
    dragPlace(place) {
      this.currentPlace = {
        lat: place.latLng.lat(),
        lng: place.latLng.lng(),
        address:  place.formatted_address,
        country:  this.getPlaceData(place.address_components, 'country'),
        province:  this.getPlaceData(place.address_components, 'administrative_area_level_1'),
        city:  this.getPlaceData(place.address_components, 'administrative_area_level_2'),
        area:  this.getPlaceData(place.address_components, 'administrative_area_level_3')
      }
      this.center = this.currentPlace
    },
    toggleModalCoordinate() {
      this.showModalCoordinate = !this.showModalCoordinate
    },
    openModalCoordinate(scheduleIndex, listingIndex) {
      this.scheduleIndex = scheduleIndex
      this.locationIndex = listingIndex
      this.toggleModalCoordinate()
    },
    closeModalCoordinate() {
      this.currentPlace = null
      this.locationIndex = null
      this.scheduleIndex = null
      this.toggleModalCoordinate()
    },
    saveCoordinate() {
      this.schedules[this.scheduleIndex]['listings'][this.locationIndex].latitude = this.currentPlace.lat
      this.schedules[this.scheduleIndex]['listings'][this.locationIndex].longitude = this.currentPlace.lng
      this.schedules[this.scheduleIndex]['listings'][this.locationIndex].city = this.currentPlace.city.long_name
      this.schedules[this.scheduleIndex]['listings'][this.locationIndex].area = this.currentPlace.area.long_name
      this.currentPlace = null
      this.locationIndex = null
      this.scheduleIndex = null
      this.toggleModalCoordinate()
    },
    addSchedule() {
      this.schedules.unshift({
        taskStart: new Date(),
        visitPeriod: 3,
        listings: []
      })
    },
    selectPayment(item){
      this.selectedPayment = item
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang="scss">
.campaign {
  .modal__content__header {
    margin-bottom: 30px;
    button{
      width: 0;
      height: 0;
    }
  }
  &__main {
    &__right {
      &__date, &__duration {
        &__status {
          .dropdown-status__menu__wrapper{
            max-height: 200px;
          }
        }
      }
    }
  }
}

</style>
